import {Link} from "react-router-dom";
import moment from "moment";
import "./blog-item.scss";
import {withLanguage} from "../../assets/js/contexts";
import {useLang} from "../../helpers/language";
import parse from "html-react-parser";
import config from "../../config";
import React from "react";

const BlogItem = ({item, windowWidth, index , refresh}) => {
    const {lang} = useLang();

    return (
        <div className="blog-item">
            <Link to={
                `/blog-post/${
                    item._id
                }?lang=${lang}`
            } onClick={refresh}>
                    <div>
                        <div className="image-wrapper">
                            <img src={
                                    item.uploads ? `${
                                        config.api.API_URL
                                    }/${
                                        item.uploads[0]?.path
                                    }` : ""
                                }
                                width="100%" alt=""/>
                        </div>
                        <div className="content-wrapper">
                            <div>
                                <span className="date">
                                    {
                                    moment(item.date).format("MM-DD-YYYY")
                                }</span>
                                <h4>{
                                    item?.title && item?.title[lang]
                                }</h4>
                            </div>
                            {
                                parse(item?.desc ? item.desc[lang] ? item.desc[lang].slice(0, 200) : "" : "")
                            }
                        </div>
                    </div>
            </Link>
        </div>
    );
};

export default withLanguage(BlogItem);
